import { ShoppingCartOutlined, TableOutlined, CalendarOutlined, ThunderboltOutlined, ScheduleOutlined } from '@ant-design/icons';
import type { StageConfig } from './types';

export type PurchaseStage1View = 'planning' | 'periods' | 'dynamic';
export type PurchaseStage2View = '2s8m' | '2s2d';

export const PURCHASE_STAGES: StageConfig[] = [
  {
    title: '1 этап',
    description: 'План закупок по ЦПР-ТН',
    icon: <ShoppingCartOutlined />,
    path: 'stage-1',
    rbacResource: 'purchase_stage1',
    views: [
      { key: 'planning', label: 'Планирование', icon: <TableOutlined /> },
      // Б/у-представления 1.0 — только для 2026 года, с 2027 не показываются
      { key: 'periods', label: 'Периоды', icon: <CalendarOutlined />, maxYear: 2026 },
      { key: 'dynamic', label: 'Динамический ПЗ', icon: <ThunderboltOutlined />, maxYear: 2026 },
    ],
  },
  {
    title: '2 этап',
    description: 'План закупок ЦПР-ТН-SKU',
    icon: <ScheduleOutlined />,
    path: 'stage-2',
    rbacResource: 'purchase_stage2',
    views: [
      { key: '2s8m', label: 'Таблица 2s8m', icon: <CalendarOutlined /> },
      { key: '2s2d', label: 'Таблица 2s2d', icon: <TableOutlined /> },
    ],
  },
];
